module.exports = __webpack_public_path__ + "static/media/3-how-to.f989164d.png";